<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Students</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            class="btn add-btn"
            @click="
              $router.push({
                name:
                  tokenObj.UserType == userTypeMainAdmin
                    ? 'mainAdminStudentAdd'
                    : 'schoolAdminStudentAdd',
              })
            "
          >
            <i class="fa fa-plus"></i>Add Student
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-4" v-if="tokenObj.UserType == userTypeMainAdmin">
        <div class="form-group">
          <label>School</label>
          <select class="form-control" v-model="schoolId">
            <option value>All</option>
            <option v-for="item in schools" :value="item.Id" :key="item.Id">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Student Name</label>
          <input
            type="text"
            placeholder="Search Name Here"
            class="form-control"
            v-model="name"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Status (Filter)</label>
          <select class="form-control" v-model="status">
            <option value>All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">View</button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th class="id-col">
                  <button class="btn p-0" @click="setSortBy('id')">
                    ID
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'id'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'id_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="name-col">
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="contact-col">
                  <button class="btn p-0" @click="setSortBy('contactNumber')">
                    Contact Number
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'contactNumber'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'contactNumber_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="email-col">
                  <button class="btn p-0" @click="setSortBy('email')">
                    Email
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'email'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'email_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-col">
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in students" :key="item.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td class="id-col">{{ item.UserName }}</td>
                <td class="name-col">{{ item.Name }}</td>
                <td class="contact-col">{{ item.ContactNumber }}</td>
                <td class="email-col">{{ item.Email }}</td>
                <td class="status-col">{{ item.Status }}</td>
                <td class="action-col">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminStudentShow'
                                : 'schoolAdminStudentShow',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-file-alt mr-2"></i>View
                      </button>
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminStudentEdit'
                                : 'schoolAdminStudentEdit',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="fa fa-pencil mr-2"></i>Edit
                      </button>
                      <button
                        class="dropdown-item"
                        @click="deleteStudent(item.Id)"
                      >
                        <i class="fa fa-trash-o mr-2"></i>Delete
                      </button>
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminStudentDocument'
                                : 'schoolAdminStudentDocument',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-folder-open mr-1"></i>View Documents
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="students && !students.length">
                <td colspan="7" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="students && students.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          students.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import $ from "jquery";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      noRecordText: config.NO_RECORD_TEXT,
      schools: [],
      schoolId: "",
      name: "",
      status: "",
      students: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getStudentList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    search() {
      //set the state from filter
      this.$store.state.studentFilter.schoolId = this.schoolId;
      this.$store.state.studentFilter.studentName = this.name;
      this.$store.state.studentFilter.status = this.status;
      this.paging.CurrentPage = 1;
      this.getStudentList();
    },
    deleteStudent(studentId) {
      let param = {
        Token: this.tokenObj.Token,
        Id: studentId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the student?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.student
            .deleteStudent(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.paging.CurrentPage = 1;
                this.getStudentList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getStudentList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        Name: this.name,
        Status: this.status,
      };
      this.$store.state.isLoading = true;
      API.student
        .getStudentList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.students = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getStudentList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getStudentList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getStudentList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getStudentList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getStudentList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "id":
          if (this.paging.SortBy === "id") {
            this.paging.SortBy = "id_desc";
          } else if (this.paging.SortBy === "id_desc") {
            this.paging.SortBy = "id";
          } else {
            this.paging.SortBy = "id";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "contactNumber":
          if (this.paging.SortBy === "contactNumber") {
            this.paging.SortBy = "contactNumber_desc";
          } else if (this.paging.SortBy === "contactNumber_desc") {
            this.paging.SortBy = "contactNumber";
          } else {
            this.paging.SortBy = "contactNumber";
          }
          break;
        case "email":
          if (this.paging.SortBy === "email") {
            this.paging.SortBy = "email_desc";
          } else if (this.paging.SortBy === "email_desc") {
            this.paging.SortBy = "email";
          } else {
            this.paging.SortBy = "email";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getStudentList();
    },
  },
  created() {
    //populate the filter from state
    let studentFilter = this.$store.state.studentFilter;
    this.schoolId = studentFilter.schoolId;
    this.name = studentFilter.studentName;
    this.status = studentFilter.status;
    this.getStudentList();
    this.getSchools();
  },
};
</script>

<style scoped>
table {
  min-height: 150px;
}
.id-col {
  width: 15%;
}
.contact-col {
  width: 198px;
}
.email-col {
  width: 25%;
}
.status-col {
  width: 122px;
}
</style>



// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/StudentList.vue